// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export const breadcrumbConstants = {
  allProjects: 'All Projects',
  common: '- Common',
};
